import { Box, Grid, Heading, Skeleton, VStack } from '@chakra-ui/react';
import { HiTicket } from 'react-icons/hi2';
import { LuCrown } from 'react-icons/lu';
import { useNavigate } from 'react-router-dom';
import { urlNavigate } from '../../../helper/utils/navigation';
import QuickAccessTile from '../components/QuickAccessTile';
import UserProfileCard from '../components/UserProfileCard';
import { useUserProfile } from '../hooks/useUserProfile';

export default function DashboardHome() {
    const navigate = useNavigate();

    const { user, isLoading: userLoading } = useUserProfile();

    const handleEditProfile = () => {
        navigate(urlNavigate('dashboard', 'account-details'));
    };

    const handleViewCreditHistory = () => {
        navigate(urlNavigate('dashboard', 'credit-balance'));
    };

    const handleViewPointsHistory = () => {
        navigate(urlNavigate('dashboard', 'points'));
    };

    const handleNavigateToVouchers = () => {
        navigate(urlNavigate('dashboard', 'vouchers'));
    };

    const handleNavigateToCoupons = () => {
        navigate(urlNavigate('dashboard', 'coupons'));
    };

    const handleNavigateToOrders = () => {
        navigate(urlNavigate('dashboard', 'orders'));
    };

    const handleNavigateToMembership = () => {
        navigate(urlNavigate('dashboard', 'membership'));
    };

    const handleNavigateToTickets = () => {
        navigate(urlNavigate('online-sales', 'home'));
    };

    return (
        <VStack spacing={{ base: 4, md: 6 }} align='stretch' w='full'>
            {/* Page Header */}
            <Box>
                <Heading size={{ base: 'md', md: 'lg' }} color='gray.800' mb={2} mt={{ base: 5, md: 0 }} textAlign={{ base: 'center', md: 'left' }}>
                    MY ACCOUNT
                </Heading>
            </Box>

            {/* User Profile Card */}
            {userLoading ? <Skeleton height={{ base: '250px', md: '200px' }} borderRadius='2xl' /> : <UserProfileCard user={user} onEdit={handleEditProfile} />}

            {/* Balance Cards */}
            {/* <Grid templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }} gap={{ base: 4, md: 6 }}>
                {balanceLoading ? (
                    <>
                        <Skeleton height={{ base: '180px', md: '200px' }} borderRadius='2xl' />
                        <Skeleton height={{ base: '180px', md: '200px' }} borderRadius='2xl' />
                    </>
                ) : (
                    <>
                        <BalanceCard type='credit' balance={creditBalance} onViewHistory={handleViewCreditHistory} />
                        <BalanceCard type='points' balance={points} onViewHistory={handleViewPointsHistory} />
                    </>
                )}
            </Grid> */}

            {/* Quick Access Tiles */}
            <Grid templateColumns={{ base: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' }} gap={{ base: 3, sm: 4, md: 6 }}>
                <QuickAccessTile icon={HiTicket} label='Buy Ticket' onClick={handleNavigateToTickets} colorScheme='primary' />
                <QuickAccessTile icon={LuCrown} label='Membership' onClick={handleNavigateToMembership} colorScheme='green' />
                {/* <QuickAccessTile icon={FiGift} label='Vouchers' onClick={handleNavigateToVouchers} colorScheme='green' />
                <QuickAccessTile icon={FiPackage} label='Coupons' onClick={handleNavigateToCoupons} colorScheme='pink' />
                <QuickAccessTile icon={FiShoppingBag} label='Orders' onClick={handleNavigateToOrders} colorScheme='orange' /> */}
            </Grid>
        </VStack>
    );
}
